import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

createApp(App)
  .use(router)
  .mount('#app');


async function logAppVersion() {
  try {
    const response = await fetch('/config.json');
    const config = await response.json();
    const version = config.version || 'Версия не указана';

    // console.log(
    //   `%c 🌟 Приложение запущено: %c${version}`,
    //   'color: #888; font-size: 14px;',
    //   'color: #42b983; font-size: 14px; font-weight: bold;'
    // );
  } catch (error) {
    console.warn('Не удалось загрузить config.json для отображения версии');
  }
}

logAppVersion();

async function checkVersionAndClearCache() {
  try {
    const response = await fetch('/config.json', { cache: 'no-store' });
    const config = await response.json();
    const latestVersion = config.version;

    const storedVersion = localStorage.getItem('app_version');

    if (storedVersion && storedVersion !== latestVersion) {
      console.warn(`[App] Версия изменилась: ${storedVersion} → ${latestVersion}`);
      localStorage.setItem('app_version', latestVersion);
      // Очистим кэш и перезагрузим страницу
      caches.keys().then(function (names) {
        for (let name of names) caches.delete(name);
      }).finally(() => {
        location.reload(true);
      });
    } else {
      localStorage.setItem('app_version', latestVersion);
      console.log(`%c[App] Версия ${latestVersion}`, 'color: green; font-weight: bold;');
    }
  } catch (e) {
    console.error('[App] Ошибка при проверке версии:', e);
  }
}

checkVersionAndClearCache();
